<template>
  <v-card flat>
    <v-stepper v-model="e6">
      <v-stepper-items>
        <!-- stepper one -->
        <v-stepper-content step="1">
          <!-- show -->
          <v-card flat v-if="items?.length > 0">
            <!-- filter disgn -->
            <v-row>
              <v-col cols="12" md="4">
                <v-combobox
                  @change="filterFetch()"
                  :loading="fLoading"
                  :disabled="fLoading"
                  v-model="filtersItem.parent_id"
                  :items="filters"
                  :item-text="'title'"
                  :item-value="'id'"
                  dense
                  outlined
                  label="فیلتر محصولات"
                />
              </v-col>
              <!--  -->
              <v-col cols="12" md="4">
                <v-text-field
                  :disabled="loading"
                  v-model="filtersItem.search"
                  dense
                  outlined
                  label="جستجو"
                  @keyup.enter="filterFetch"
                  @click:append="filterFetch()"
                  append-icon="mdi-magnify"
                />
              </v-col>
              <!--  -->
              <v-col class="text-center" cols="12" md="4">
                <v-btn
                  :loading="oLoading"
                  @click="contentBuy && !oLoading ? getPrices(true) : null"
                  color="green"
                  outlined
                  :disabled="contentBuy == 0"
                >
                  <!-- <v-badge
                    absolute
                    bordered
                    v-if="contentBuy"
                    color="black"
                    :content="contentBuy"
                    transition="scale-rotate-transition"
                  >
                  </v-badge> -->
                  <v-icon size="20">mdi-basket-outline</v-icon>
                  تکمیل خرید
                  <b class="red--text" v-if="contentBuy > 0"
                    >({{ contentBuy }})</b
                  >
                </v-btn>
              </v-col>
            </v-row>
            <!-- card -->
            <v-row no-gutters v-if="!!items">
              <v-col
                v-for="(item, i) in items"
                :key="i"
                class="pa-3 fill-height deck-col"
                cols="12"
                md="4"
              >
                <v-card class="rounded-0" outlined>
                  <div class="pa-4 overflow-hidden text-center">
                    <div class="deck">
                      <div class="card">
                        <div class="front face">
                          <v-img
                            :aspect-ratio="0.619"
                            :src="item?.image"
                            style="height: 86% !important"
                          ></v-img>
                          <v-card-title
                            class="mt-0 pt-0 text-center algin-center justify-center"
                          >
                            {{ use_lang(item?.price?.toLocaleString()) }} ﷼
                          </v-card-title>
                        </div>
                        <div
                          class="back face d-flex flex-column align-items-center justify-content-center text-center"
                        >
                          <v-card-title
                            class="d-flex text-break justify-content-center"
                            >{{ item?.parent?.title }}</v-card-title
                          >
                          <v-card-subtitle>{{ item?.title }}</v-card-subtitle>
                          <!-- <v-card-subtitle>
                            {{ persian(item?.price?.toLocaleString()) }} ﷼
                          </v-card-subtitle> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </v-card>

                <v-btn-toggle
                  v-if="!!findItemBuy(item.id)"
                  class="w-100 order_btn justify-content-center mt-2 white--text"
                  color="green"
                >
                  <v-btn
                    outlined
                    v-for="(button, i) in buttons"
                    :key="i"
                    :style="{ width: button.width }"
                    :color="button?.color"
                    @click="
                      button.fun != 'none' && buyHandler(item, button.fun)
                    "
                  >
                    <template v-if="!!button.title">
                      <v-icon
                        v-if="
                          (button.fun == 'min' &&
                            findItemBuy(item.id)?.count < 2) ||
                          button.fun == 'add'
                        "
                        :color="button?.color"
                        size="25"
                      >
                        {{ button.icon }}
                      </v-icon>

                      <v-icon
                        :color="button?.color"
                        v-if="
                          button.fun == 'min' && findItemBuy(item.id)?.count > 1
                        "
                      >
                        mdi-minus-circle
                      </v-icon>
                      <!-- {{ button?.title }} -->
                    </template>
                    <template v-else>
                      <b>{{ findItemBuy(item.id)?.count }}</b>
                    </template>
                  </v-btn>
                </v-btn-toggle>

                <v-btn
                  v-else
                  @click="buyHandler(item, 'add')"
                  class="w-100 order_btn mt-2 white--text"
                  color="green"
                >
                  <template v-if="!!item?.price">
                    <v-icon>mdi-plus</v-icon>
                    سفارش محصول
                  </template>
                </v-btn>
              </v-col>

              <template v-if="loading && !!items">
                <v-col
                  v-for="loader in 3"
                  :key="`loader-${loader}`"
                  class="pa-3 fill-height deck-col"
                  cols="12"
                  md="4"
                >
                  <v-card class="rounded-0" outlined>
                    <div class="pa-4 overflow-hidden text-center">
                      <div class="deck">
                        <div class="card">
                          <div class="front face">
                            <v-skeleton-loader min-height="300" type="image" />
                          </div>
                        </div>
                      </div></div
                  ></v-card>
                </v-col>
              </template>

              <v-col cols="12">
                <v-card v-intersect="onIntersect" flat></v-card>
              </v-col>
            </v-row>
          </v-card>

          <!-- loading -->
          <v-card
            v-if="loading && items?.length == 0"
            class="d-flex align-center justify-center"
            flat
            height="300"
          >
            <atom-spinner
              :animation-duration="1500"
              :size="100"
              class="mx-auto"
              color="var(--v-primary-base)"
            />
          </v-card>
        </v-stepper-content>

        <!-- stepper two -->
        <v-stepper-content step="2">
          <v-card-actions class="d-flex align-items-center justify-content-end">
            <v-btn color="red" outlined @click="e6 = 1" v-if="stepper < 2">
              بازگشت

              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
          </v-card-actions>
          <v-scroll-x-transition mode="out-in">
            <v-card v-if="stepper == 1" class="border rounded-xl mb-2" flat>
              <!-- how to get -->
              <v-card-text class="pa-0 px-2">
                <v-radio-group v-model="data.delivery_methode">
                  <v-radio value="post">
                    <template v-slot:label>
                      <v-card-subtitle class="pa-0">
                        <v-icon>mdi-email</v-icon>
                        در زمان ثبت، هزینه پست و 10 درصد مالیات (روی مبلغ سفارش)
                        از کیف پول شما کسر خواهد شد.
                      </v-card-subtitle>
                    </template>
                  </v-radio>
                  <v-radio value="company">
                    <template v-slot:label>
                      <v-card-subtitle class="pa-0">
                        <v-icon>mdi-office-building</v-icon>
                        تحویل حضوری
                      </v-card-subtitle>
                    </template>
                  </v-radio>
                </v-radio-group>
              </v-card-text>

              <!-- informations -->
              <v-card-text
                v-if="data.delivery_methode == 'post'"
                class="pa-0 px-2"
              >
                <v-card-title>اطلاعات ارسال</v-card-title>
                <v-divider class="mx-4 mt-0" />
                <v-text-field
                  type="number"
                  class="pa-2 rounded-lg"
                  v-model="contentBuy"
                  readonly
                  hide-details
                  outlined
                  label="تعداد سفارش"
                  dense
                />
                <user-address-picker v-model="data" />
              </v-card-text>
            </v-card>

            <v-card v-if="stepper == 2" class="border rounded-xl mb-2" flat>
              <v-card-title
                class="d-flex justify-content-center align-items-center"
                >خرید شما با موفقیت انجام شد</v-card-title
              >
              <v-card-subtitle
                class="d-flex justify-content-center align-items-center"
              >
                <v-btn
                  outlined
                  color="green"
                  class="my-2"
                  @click="
                    e6 = 1;
                    resetFilter();
                    item_buy = [];
                  "
                >
                  <v-icon>mdi-backup-restore</v-icon>
                  بازگشت به صفحه اصلی
                </v-btn>
              </v-card-subtitle>
            </v-card>

            <v-card
              v-if="stepper == 3 && errors"
              class="border text-center rounded-xl mb-2"
              flat
            >
              <v-card-title
                class="d-flex justify-content-center align-items-center"
                >{{ message }}</v-card-title
              >
              <v-btn
                @click="
                  resetFilter();
                  e6 = 1;
                "
                class="my-2"
                outlined
                color="red"
              >
                <v-icon>mdi-backup-restore</v-icon>
                بازگشت به صفحه اصلی
              </v-btn>
            </v-card>
          </v-scroll-x-transition>

          <v-fade-transition v-if="stepper < 2">
            <v-card class="rounded-lg" outlined>
              <!-- sumPrice -->
              <div class="px-4 pt-4 d-flex align-center">
                قیمت کل: ({{ contentBuy }})
                <span class="mx-1 grey--text"> </span>
                <v-spacer />
                <b
                  v-if="!!info?.discount"
                  class="red--text text-decoration-line-through"
                >
                  {{ persian(info?.sumPrice?.toLocaleString()) }}
                </b>
                <b v-else class="red--text">{{
                  persian(info?.sumPrice?.toLocaleString())
                }}</b>
                <span class="red--text ms-1">ریال</span>
              </div>
              <v-divider class="mb-0 mx-4" />

              <!-- fee -->
              <div
                v-if="!!info?.discount"
                class="px-4 pt-4 d-flex align-center"
              >
                قیمت با تخفیف:
                <span class="mx-1 grey--text">({{ persian(contentBuy) }})</span>
                <v-spacer />
                <b>{{
                  persian(info?.allPriceAddDiscount?.toLocaleString())
                }}</b>
                <span class="grey--text ms-1">ریال</span>
              </div>
              <v-divider v-if="!!info?.discount" class="mb-0 mx-4" />

              <!-- send product -->
              <div v-if="!!info?.sp" class="px-4 pt-4 d-flex align-center">
                هزینه ارسال:
                <v-spacer />
                <b>{{ persian(info?.sp?.toLocaleString()) }}</b>
                <span class="grey--text ms-1">ریال</span>
              </div>
              <v-divider v-if="!!info?.sp" class="mb-0 mx-4" />

              <!-- profit -->

              <div class="px-4 pt-4 d-flex align-center green--text">
                سود شما از خرید:
                <v-spacer />
                <!-- <span class="me-1 grey--text"
            >({{ computedPrice.discount }}% تخفیف)</span
          > -->
                <b>{{ persian(info?.profit?.toLocaleString()) }}</b>
                <span class="grey--text ms-1">ریال</span>
              </div>

              <!-- alarm -->
              <div class="px-4 mt-4">
                <v-alert border="left" class="white--text" color="red" dense>
                  ۱۰٪ مالیات به مبلغ نهایی افزوده خواهد شد.
                </v-alert>
              </div>

              <!-- all price -->
              <div class="px-4 d-flex align-center">
                مبلغ قابل پرداخت:
                <v-spacer />
                <b>{{ persian(info?.allPrice?.toLocaleString()) }}</b>
                <span class="grey--text ms-1">ریال</span>
              </div>

              <div class="px-4 pb-2 d-flex align-center">
                <v-btn
                  v-if="stepper == 1"
                  :loading="oLoading"
                  @click="getPrices(false)"
                  :disabled="!payBuy"
                  class="w-100"
                  outlined
                  color="green"
                >
                  <v-icon>mdi-plus</v-icon>
                  پرداخت
                </v-btn>
              </div>
            </v-card>
          </v-fade-transition>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-card>
</template>

<script>
import { AtomSpinner } from "epic-spinners";
import UserAddressPicker from "../../../../components/pickers/userAddressPicker.vue";
export default {
  components: { AtomSpinner, UserAddressPicker },
  name: "equipmentNfc",

  props: {
    reset: Boolean,
    qrId: [Number, String],
  },

  data() {
    return {
      items: [],
      item_buy: [],
      e6: 1,
      stepper: 1,
      //   loading first
      loading: false,
      fLoading: false,
      oLoading: false,

      // error
      errors: false,
      message: "",
      // buttons
      buttons: [
        {
          title: "افزودن تعداد خرید",
          icon: "mdi-plus-circle",
          width: "20%",
          color: "green",
          fun: "add",
        },
        { title: "", icon: "", width: "12%", color: "none", fun: "none" },
        {
          title: "کاهش تعداد خرید",
          icon: "mdi-delete",
          width: "20%",
          color: "red",
          fun: "min",
        },
      ],

      data: {
        province: "",
        postal_code: "",
        city: "",
        delivery_methode: "post",
        address: "",
        qr_id: "",
      },

      // filter
      filters: [],
      filtersItem: {
        parent_id: null,
        search: "",
        page: 1,
        length: 10,
      },
      // pages
      number_page: null,

      // prices
      prices: {},
    };
  },

  watch: {
    reset(val) {
      if (val) {
        this.resetFilter();
        this.fetchFilter();
        this.fetch();
        this.items = [];
        this.item_buy = [];
      }
    },
  },

  computed: {
    info() {
      let price = this.prices?.items || [];
      let sp = this.data.delivery_methode == "post" ? 790000 : 0;
      let fee = 0.1;
      let profit = 0;
      let discount = 0;
      let pDiscount = 0;
      let allPriceFee = 0;

      const gets = () => {
        let sumPrice = 0;
        let profitLocal = 0;
        let discountLocal = 0;
        let sumPriceDiscount = 0;

        price?.forEach((item) => {
          let final = item?.finalPrice || 0;
          sumPrice += final;

          let priceOfAll = item?.priceOne || 0;
          let priceOfDiscount =
            priceOfAll - priceOfAll * (item?.discount || 0) * 0.01;
          profitLocal += (item?.count || 0) * (priceOfAll - priceOfDiscount);

          sumPriceDiscount += item?.count * (priceOfAll - priceOfDiscount);

          discountLocal += item?.discount || 0;
        });

        profit = profitLocal;
        discount = discountLocal;
        pDiscount = sumPriceDiscount;
        return sumPrice;
      };

      let sumPrice = gets();
      let allPriceAddDiscount = sumPrice - profit;
      allPriceFee = fee * allPriceAddDiscount + allPriceAddDiscount;
      let allPrice = allPriceFee + sp;

      return {
        price,
        sp,
        pDiscount,
        fee,
        profit,
        discount,
        sumPrice,
        allPrice,
        allPriceFee,
        allPriceAddDiscount,
      };
    },
    contentBuy() {
      let count = 0;
      this.item_buy.map((i) => (count += i.count));
      return count;
    },
    payBuy() {
      let delivary = this.data.delivery_methode == "post" ? true : false;

      if (delivary) {
        let datas =
          !!this.data.address &&
          !!this.data.city &&
          !!this.data.province &&
          !!this.data.postal_code;
        return datas;
      } else {
        return true;
      }
    },
  },

  mounted() {
    this.fetchFilter();
    this.fetch();
    this.data.qr_id = this.qrId;
  },

  methods: {
    // fetch card
    async fetch(paramss = this.filtersItem) {
      console.log(this.filtersItem);

      let params = { ...paramss, parent_id: paramss["parent_id"]?.id, qr_id:this.qrId };
      this.loading = true;
      try {
        await this.$api
          .get("/v1/qr-equipment", { params })
          .then(({ data }) => {
            this.e6 = 1;

            this.number_page = data.data.last_page;
            this.filtersItem.page = data.data.current_page + 1;
            this.items = [...this.items, ...data.data.data];
          })
          .catch((err) => console.log(e));
      } catch {
      } finally {
        setTimeout(() => (this.loading = false), 6);
      }
    },

    // fetch for filter
    filterFetch() {
      this.items = [];
      this.filtersItem.page = 1;
      this.fetch();
    },

    async fetchFilter() {
      this.fLoading = true;
      try {
        await this.$api.get("/v1/qr-equipment/filters").then(({ data }) => {
          this.filters = [{ title: "همه", id: null }, ...data.data];
          this.filtersItem.parent_id = this.filters[0];
        });
      } catch {
      } finally {
        this.fLoading = false;
      }
    },

    buyHandler(item, func) {
      // copy ass items select
      let items = [...this.item_buy];

      // find items on items copy
      let find = items.find((i) => i.id == item.id);

      // function for add or remove count
      this.item_buy = items?.filter((i) => i.id !== item.id);
      let sUnd = () => {
        switch (func) {
          case "add":
            find.count += 1;
            break;
          case "min":
            find.count == 0 ? 0 : (find.count -= 1);
            break;
        }
      };

      // check find for how to add
      if (!!find) {
        sUnd();
        find.count ? this.item_buy.push(find) : null;
      } else {
        this.item_buy.push({ ...item, count: 1 });
      }
    },

    findItemBuy(id) {
      let find = this.item_buy.find((item) => item.id == id);
      return find;
    },

    resetFilter() {
      this.$set(this, "filtersItem", {
        parent_id: null,
        search: "",
        page: 1,
        length: 10,
      });
      this.number_page = null;
      this.stepper = 1;
      this.message = "";
      this.errors = false;
    },

    onIntersect(entries) {
      let isIntersecting = entries[0].isIntersecting;
      if (
        this.filtersItem.page <= this.number_page &&
        isIntersecting &&
        !this.loading
      ) {
        this.fetch();
      }
    },

    // get prices
    async getPrices(type) {
      this.oLoading = true;
      try {
        let orders = this.data;
        orders.price = type;
        orders.equipments = this.item_buy.map((item) => {
          return { id: item.id, count: item?.count };
        });

        console.log(orders);

        await this.$api
          .post("/v1/qr-equipment/order/", orders)
          .then(({ data }) => {
            type ? (this.e6 = 2) : (this.stepper = 2);
            type ? (this.prices = data.data) : null;
          })
          .catch(({ response }) => {
            this.message = response.data.message;
            this.errors = true;
            this.stepper = 3;
            console.log(response.data.message);
          });
      } catch {
      } finally {
        this.oLoading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.v-dialog {
  box-shadow: none !important;
}

.v-card .v-skeleton-loader,
.v-card .v-skeleton-loader .v-skeleton-loader__bone {
  height: 100%;
}

.deck-col .order_btn {
  // visibility: hidden;
}

.deck-col:hover .order_btn {
  visibility: visible;
}

.deck {
  margin: auto;
  width: 100%;
  max-width: 150px;
  height: auto;
  aspect-ratio: 0.619;
  position: relative;
  -webkit-perspective: 1000px;
  perspective: 1000px;
  border-radius: 10px;

  &.horizontal {
    aspect-ratio: 1.615;
    max-width: 95%;
  }
}

.card {
  width: 100%;
  height: 100%;
  -webkit-transform-style: preserve-3d;
  transform-style: preserve-3d;
  -webkit-transition: all 0.5s linear;
  transition: all 0.5s linear;
  border-radius: 10px;
  box-shadow: 0 0 5px 3px rgba(0, 0, 0, 0.1);
}

.face {
  overflow: hidden;
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  background-color: whitesmoke;
  border-radius: 10px;
}

.back {
  overflow: hidden;
  z-index: 2 !important;
  display: block;
  -webkit-transform: rotateY(180deg);
  transform: rotateY(180deg);
  box-sizing: border-box;

  &:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 2 !important;
    background-size: 100% 100%;
    -webkit-transform: rotateY(180deg);
    -moz-transform: buyHandler rotateY(180deg);
    -ms-transform: rotateY(180deg);
    -o-transform: rotateY(180deg);
    transform: rotateY(180deg);
  }
}

.front,
.back {
  transition: all 0.5s linear;
}

.front {
  z-index: -1;
}

.flipped,
.card:hover {
  box-shadow: 0 0 7px 4px rgba(0, 0, 0, 0.2);
  -webkit-transform: rotateY(180deg);
  transform: rotateY(180deg);
}
</style>
